export const isBooleanLiteral = (val) => val === true || val === false;

export const toggleBooleanWithOveride = (currentValue, forceValue) =>
  isBooleanLiteral(forceValue) ? forceValue : !currentValue;
